export const MOVE_SIDE_IN_ANIMATION_NAME = "move-from-side-in";
export const MOVE_SIDE_OUT_ANIMATION_NAME = "move-from-side-out";

export const styles = {
  [`@keyframes ${MOVE_SIDE_IN_ANIMATION_NAME}`]: {
    "0%": {
      transform: "translateX(100%)",
    },

    "100%": {
      transform: "translateX(0%)",
    },
  },

  [`@keyframes ${MOVE_SIDE_OUT_ANIMATION_NAME}`]: {
    "0%": {
      transform: "translateX(0%)",
    },

    "100%": {
      opacity: "0",
      transform: "translateX(-100%)",
    },
  },
  transitionable: {
    "&.animate": {
      "&[data-animation=\"move-from-side\"]": {
        "&.in": {
          animation: `var(--animation-duration) var(--transition-easing) forwards ${MOVE_SIDE_IN_ANIMATION_NAME}`,
          zIndex: "10",
        },

        "&.out": {
          animation: `var(--animation-duration) var(--transition-easing) forwards ${MOVE_SIDE_OUT_ANIMATION_NAME}`,
          zIndex: "5",
        },

        "&.reverse": {
          "&.in": {
            animation: `var(--animation-duration) var(--transition-easing-reversed) forwards reverse ${MOVE_SIDE_OUT_ANIMATION_NAME}`,
          },

          "&.out": {
            animation: `var(--animation-duration) var(--transition-easing-reversed) forwards reverse ${MOVE_SIDE_IN_ANIMATION_NAME}`,
          },
        },
      },
    },
  },
};
